import React from 'react'
import { FaBlenderPhone, FaMailBulk } from "react-icons/fa";

const HGSContact = () => {
  return (
    <address>
        High Gloss Salon<br />
        9039 US highway 42<br />
        Suite -B<br />
        Union ,Ky 41091<br />
        <FaBlenderPhone /> 859 384 0590<br />
        <FaMailBulk /> hgsalon42@gmail.com
    </address>
  )
}

export default HGSContact